"use client"

import { useState, useEffect, useRef } from "react"
import "./ScopingSolution.css" // Assuming this is the correct CSS file for SolutionsSection
import BlueSectionDivider from "./BlueSectionDivider"
import { Link } from "react-router-dom"

const numbers = [
  { num: "+20", text: "INDUSTRY SECTORS" },
  { num: "78", text: "CUSTOMER NPS SCORE" },
  { num: "99%", text: "RECOMMENDATION RATE" },
  { num: "+300", text: "PROJECTS DELIVERED" },
]

const cards = [
  {
    id: 1,
    img: "/icons/web.png", // Replace with actual icons
    title: "Web Applications",
  },
  {
    id: 2,
    img: "/icons/mobile.png", // Replace with actual icons
    title: "MOBILE APPS",
  },
  {
    id: 3,
    img: "/icons/saas.png", // Replace with actual icons
    title: "SOFTWARE AS A SERVICE(SAAS)",
  },
  {
    id: 4,
    img: "/icons/e-commerce.png", // Replace with actual icons
    title: "E-COMMERCE PLATFORMS",
  },
  {
    id: 5,
    img: "/icons/ui.webp", // Replace with actual icons
    title: "UX/UI DESIGN",
  },
  {
    id: 6,
    img: "/icons/market.png", // Replace with actual icons
    title: "MARKETPLACES",
  },
  {
    id: 7,
    img: "/icons/bussiness.png", // Replace with actual icons
    title: "BUSINESS WEBSITES",
  },
  {
    id: 8,
    img: "/icons/cms.png", // Replace with actual icons
    title: "CONTENT MANAGEMENT WEBSITES(CMS)",
  },
  {
    id: 9,
    img: "/icons/api.webp", // Replace with actual icons
    title: "API DEVELOPMENT",
  },
  {
    id: 10,
    img: "/icons/custom.webp", // Replace with actual icons
    title: "CUSTOM SOFTWARE",
  },
  {
    id: 11,
    img: "/icons/cloud.webp", // Replace with actual icons
    title: "CLOUD-BASED APP DEVELOPMENT",
  },
  {
    id: 12,
    img: "/icons/enterprise.webp", // Replace with actual icons
    title: "ENTERPRISE SOFTWARE",
  },
  {
    id: 13,
    img: "/icons/ml.webp", // Replace with actual icons
    title: "MACHINE LEARNING AND ARTIFICIAL INTELLIGENCE",
  },
]

const SolutionsSection = (props) => {
  const [active, setActive] = useState("solution") // State for this navbar's active link
  const cardRefs = useRef([])
  const headingRef = useRef(null)
  const paraRef = useRef(null)
  const descRef = useRef(null)

  // Define section IDs for the solutions-navbar highlighting based on actual section IDs in this component
  const sectionsToHighlight = [
    "solution",
    "process", // Section exists, but no direct link in navbar for 'components'
    "benefits",
    "team",
    "tech-stack",
    "faq",
    "contact-us",
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible49")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.2 },
    )
    ;[...cardRefs.current, headingRef.current, paraRef.current, descRef.current].forEach((ref) => {
      if (ref) observer.observe(ref)
    })

    return () => observer.disconnect()
  }, [])

  // Effect for the solutions-navbar highlighting
  useEffect(() => {
    const handleScroll = () => {
      // The navbar is sticky within this section, so its top:0 is relative to the viewport
      // We only need to account for its own height as an offset for highlighting.
      const solutionsNavbarHeight = 60 // Approximate height of this solutions-navbar
      const scrollPosition = window.scrollY + solutionsNavbarHeight + 20 // Add a small buffer

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i])
        if (section && section.offsetTop <= scrollPosition) {
          setActive(sectionsToHighlight[i])
          break
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll() // Call once to set initial state

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleClick = (id) => {
    setActive(id)
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return (
    <>
    <div className="solutions-navbar49">
        <div className="container">
          <ul>
            {/* Using the links as provided in your original code */}
            {["solution", "process", "benefits", "team", "tech-stack", "faq", "contact-us"].map((item) => (
              <li key={item}>
                <a onClick={() => handleClick(item)} className={active === item ? "active" : ""}>
                  {item.toUpperCase().replace("_", " ")}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    <section className="solutions-section49" id="solution">
      {/* Solutions Section's Sticky Navbar */}
      
      <div className="content49">
        <div className="numbers-row49">
          {numbers.map((n) => (
            <div key={n.num} className="number-block49">
              <div className="big-num49">{n.num}</div>
              <div className="num-text49">{n.text}</div>
            </div>
          ))}
        </div>
        <BlueSectionDivider />
        <div className="solutions-header49">
          <h2 ref={headingRef} className="fade-in-left49">
            OUR <span className="blue">SOLUTIONS</span>
          </h2>
          <p className="solutions-intro49 fade-in-right49" ref={paraRef}>
            {props.para1}
          </p>
        </div>
        <p className="solutions-description49 fade-in-left49" ref={descRef}>
          {props.para2}
        </p>
        <div className="solutions-cards49">
          {cards.map((card, idx) => (
            <div key={card.id} className="solution-card49 fade-up49" ref={(el) => (cardRefs.current[idx] = el)}>
              <img src={card.img || "/placeholder.svg"} alt="icon" className="card-icon49" />
              <h3>{card.title}</h3>
            </div>
          ))}
        </div>
      </div>
      <div className="down-btn49">
        <Link to="/industries">
          <button>SEE INDUSTRIES WE WORK IN</button>
        </Link>
      </div>

      {/* Sub-sections for SolutionsSection, with consistent IDs */}
     
    </section>
    </>
  )
}

export default SolutionsSection
